import pl from "@locales/public_booking_picker/pl.json";
import en from "@locales/public_booking_picker/en.json";

export default { pl, en };
